import React from 'react';
import { SplashScreen } from 'src/components/loading-screen';
import { useAccessLevelContext } from '../context/access-level-context';
import useFetchPermissions from './use-fetch-permissions';

type Props = {
  children: React.ReactNode;
};

const AccessLevelConsumer = ({ children }: Props) => {
  useFetchPermissions();
  const { loadingPermissions } = useAccessLevelContext();

  if (loadingPermissions) {
    return <SplashScreen />;
  }

  return <>{children}</>;
};

export default AccessLevelConsumer;
